import { render, staticRenderFns } from "./QuestionDropdown.vue?vue&type=template&id=4db9f522&scoped=true&"
import script from "./QuestionDropdown.vue?vue&type=script&lang=js&"
export * from "./QuestionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDropdown.vue?vue&type=style&index=0&id=4db9f522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9f522",
  null
  
)

export default component.exports